"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportSubject = void 0;
var ImportSubject;
(function (ImportSubject) {
    ImportSubject["USER_IMPORT"] = "user-import";
    ImportSubject["STUDENT_IMPORT"] = "student-import";
    ImportSubject["SCHEDULE_IMPORT"] = "schedule-import";
})(ImportSubject || (exports.ImportSubject = ImportSubject = {}));
